import { Component, ElementRef, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import { fuseAnimations } from '../../../core/animations';
import { MatPaginator, MatSort } from '@angular/material';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/map';
import { Router } from "@angular/router";
import { MatDialog } from '@angular/material';
import { DialogComponent } from './dialog/dialog.component';
import { map } from 'rxjs/operators';
import { AngularFirestore } from 'angularfire2/firestore';

@Component({
    selector: 'app-contact-infos',
    templateUrl: './contact-infos.component.html',
    styleUrls: ['./contact-infos.component.scss'],
    animations: fuseAnimations
})
export class ContactInfosComponent implements OnInit, OnDestroy {

    displayedColumns = ['product', 'category', 'date', 'delete'];
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild('filter') filter: ElementRef;
    @ViewChild(MatSort) sort: MatSort;
    number: any;
    forms: Array<any>;
    dataSource: MyDataSource;
    private sub: any;

    constructor(
        private afs: AngularFirestore,
        private router: Router,
        private dialog: MatDialog) {
        console.log("ss")


        this.sub = afs.collection("contactForms", ref => ref.where("isSeen", "==", false)).snapshotChanges().pipe(map((res: any) => {
            return res.map(data => {

                return {
                    key: data.payload.doc.id,
                    ...data.payload.doc.data()
                }
            })
        }
        )).subscribe(res => {
            this.number = res.length;
            this.forms = res;
            console.log(this.forms);
            this.dataSource = new MyDataSource(this.forms, this.paginator, this.sort);
        })


    }

    ngOnInit() {




    }
    searchKeyUp(value) {
    }
    ngOnDestroy(): void {
        this.sub.unsubscribe();
    }
    navigate(key) {
        this.router.navigate(['/userlist'], { queryParams: { name: key } });
    }
    dialogSuggestions(key, type) {
        console.log(key);
        this.dialog.open(DialogComponent, {
            data: {
                key: key,
                type: type
            }
        });
    }
    sendEmail(product, modalType) {
        this.dialog.open(DialogComponent, {

            data: {
                product: product,
                modalType: modalType
            }
        });
    }
}

export class MyDataSource extends DataSource<any> {
    constructor(
        private data: any,
        private _paginator: MatPaginator,
        private _sort: MatSort) {
        super();
    }
    _filterChange = new BehaviorSubject('');
    _filteredDataChange = new BehaviorSubject('');

    get filteredData(): any {
        return this._filteredDataChange.value;
    }

    set filteredData(value: any) {
        this._filteredDataChange.next(value);
    }

    get filter(): string {
        return this._filterChange.value;
    }

    set filter(filter: string) {
        this._filterChange.next(filter);
    }
    /** Connect function called by the table to retrieve one stream containing the data to render. */
    connect(): Observable<any[]> {
        const displayDataChanges = [
            this.data,
            this._paginator.page,
            this._filterChange,
            this._sort.sortChange
        ];
        return Observable.merge(...displayDataChanges).map(() => {
            let data = this.data.slice();

            this.filteredData = [...data];

            data = this.sortData(data);

            // Grab the page's slice of data.
            const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
            return data.splice(startIndex, this._paginator.pageSize);
        });
    }

    sortData(data): any[] {
        if (!this._sort.active || this._sort.direction === '') {
            return data;
        }

        return data.sort((a, b) => {
            let propertyA: number | string = '';
            let propertyB: number | string = '';

            switch (this._sort.active) {
                case 'id':
                    [propertyA, propertyB] = [a.id, b.id];
                    break;
                case 'name':
                    [propertyA, propertyB] = [a.name, b.name];
                    break;
                case 'categories':
                    [propertyA, propertyB] = [a.categories[0], b.categories[0]];
                    break;
                case 'price':
                    [propertyA, propertyB] = [a.priceTaxIncl, b.priceTaxIncl];
                    break;
                case 'quantity':
                    [propertyA, propertyB] = [a.quantity, b.quantity];
                    break;
                case 'active':
                    [propertyA, propertyB] = [a.active, b.active];
                    break;
            }

            const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
            const valueB = isNaN(+propertyB) ? propertyB : +propertyB;

            return (valueA < valueB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1);
        });
    }

    disconnect() { }

}




// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/contact-infos/contact-infos.component.ts